/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';
import { getEventId } from '@e180/domain/lib/event/util';
import { getMembershipId } from '@e180/domain/lib/membership/util';

import SignupAuthenticationWizardDumb from './SignupAuthenticationWizardDumb';
import {
  showSignupEmailForm,
  showSignupPasswordForm,
  validateSignupActivationCode,
  validateSignupEmail,
  signupCreateUser,
} from 'src/shared/app/signup/action/signupActions';
import {
  selectSignupEmail,
  selectSignupCode,
  selectIsPasswordSet,
} from 'src/shared/app/signup/selector/appSignupSelector';
import {
  isValidationEmailFormShown,
  isValidationPasswordFormShown,
} from 'src/shared/app/signup/selector/uiSignupSelector';
import { throwFormikSubmissionError } from 'src/shared/app/base/form/util/formUtil';
import {
  completeOnboarding,
  completeOnboardingOptimistically,
} from 'src/shared/app/onboarding/action/onboardingActions';
import { isOnboardingCompletedOnDevice } from 'src/shared/app/onboarding/selector/uiOnboardingSelectors';
import { getEventPublicData } from 'src/shared/domain/event/selector/eventSelectors';

import type { State } from 'src/shared/core/type/reduxTypes';

const mapStateToProps = (state: State): Object => ({
  showEmailForm: isValidationEmailFormShown(state),
  showPasswordForm: isValidationPasswordFormShown(state),
  isPasswordSet: selectIsPasswordSet(state),
  // Used in `mergeProps` only
  event: getEventPublicData(state),
  email: selectSignupEmail(state),
  code: selectSignupCode(state),
  isOnboardingCompleted: isOnboardingCompletedOnDevice(state),
});

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (stateProps: Object, { dispatch }: Object) => {
  const { event, email: savedEmail, code, isOnboardingCompleted } = stateProps;
  const eventId = getEventId(event);

  return {
    ...stateProps,
    handleActivationSubmit({ code }: Object) {
      return dispatch(validateSignupActivationCode(code, eventId))
        .then(() => dispatch(showSignupEmailForm()))
        .catch((e) => throwFormikSubmissionError(e));
    },
    handleEmailSubmit({ email }: Object) {
      return dispatch(validateSignupEmail(email, code, eventId))
        .then(() => dispatch(showSignupPasswordForm()))
        .catch((e) => throwFormikSubmissionError(e));
    },
    handlePasswordSubmit({ password }: Object) {
      return dispatch(signupCreateUser(savedEmail, password, code, eventId))
        .then(({ membership }) => {
          if (isOnboardingCompleted) {
            // TODO: merge 2 calls
            dispatch(
              completeOnboardingOptimistically(getMembershipId(membership)),
            );
            dispatch(completeOnboarding(eventId));
          }
        })
        .catch((e) => throwFormikSubmissionError(e));
    },
    handlePasswordBack() {
      return dispatch(showSignupEmailForm());
    },
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(SignupAuthenticationWizardDumb);
